import { useEffect } from "react";

import { startChameleonPushCorrection } from "utilities/thirdPartyIntegrations/chameleon/chameleonPush";

let activeInstances = 0;
let cleanup: (() => void) | undefined;

/**
 * Keeps `position: fixed` chrome usable while a Chameleon push-mode banner is
 * up. See {@link startChameleonPushCorrection} for what Chameleon does and how
 * each symptom is corrected.
 *
 * Safe to mount more than once - instances are refcounted, so they share a
 * single watcher and only the last one to unmount tears it down.
 *
 * @param enabled Whether Chameleon is running. Nothing is watched when false.
 */
export function useChameleonPushCorrection(enabled: boolean): void {
    useEffect(() => {
        if (!enabled || typeof MutationObserver === "undefined") {
            return;
        }

        activeInstances += 1;

        if (activeInstances === 1) {
            cleanup = startChameleonPushCorrection();
        }

        return () => {
            activeInstances -= 1;

            if (activeInstances === 0) {
                cleanup?.();
                cleanup = undefined;
            }
        };
    }, [enabled]);
}
